export class GeneralError extends Error {
    constructor(httpResponse) {
        var _a, _b;
        super((_a = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.body) === null || _a === void 0 ? void 0 : _a.error);
        this.name = (_b = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.body) === null || _b === void 0 ? void 0 : _b.type;
    }
}
